import { MutableRefObject } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

import type { IIntendCache } from '../useOverlayingWebView';

import { setAndroidPart } from './setAndroidPart';

const PLATFORM = Capacitor.getPlatform();

// The function should set platform related variables only once
// It prevents layout jumps while keyboard interaction as instance
let ONCE = false;

/**
 * @param style is a link on document.documentElement.style
 */
export const setPlatformsOnce = async (
	style: CSSStyleDeclaration,
	cache: MutableRefObject<IIntendCache>
) => {
	if (!ONCE) {
		if (PLATFORM === 'android') {
			await setAndroidPart(style, cache);
		}

		if (PLATFORM !== 'web') {
			await StatusBar?.setStyle({ style: Style.Light });
		}

		ONCE = true;
	}
};
